import styled from "styled-components"
import {down} from "styled-breakpoints";

export const Wrapper = styled.div`
    font-family: Archivo;

    > .container {
        ${down("md")}{
            max-width: 100%;
        }
        > .first_content.header {
            display: none !important;

        }
    }

    .first_content.header {
        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.47px;
        text-transform: capitalize;

        .close-btn {
            display: none;
        }

        ${down("md")} {
            .close-btn {
                display: block;
            }

            font-weight: 500;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0px;
            text-transform: capitalize;
        }
    }

    .cart-delivery-info-pad {
        padding: 18px 14px;
        border-radius: 7.5px;
    }

    .c-stepper {
        list-style: none;

        > .c-stepper__item {
            position: relative;
            border-inline-start: 2px dashed #0B9C07;
            margin-inline-start: 1rem;

            .c-stepper__content {
                flex: 1;
                padding-inline-start: 1.5rem;

                b {
                    font-weight: 500;
                }
            }

            .c-stepper__dot {
                position: absolute;
                inset-inline-start: -1rem;

                > div {
                    width: 2rem;
                    height: 2rem;
                    position: relative;
                    border: 2px solid #CEEBCD;
                    background-color: white;

                    border-radius: 50%;


                    &:before {
                        content: "";
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: .75rem;
                        height: .75rem;
                        background-color: var(--color-primary);
                        border-radius: 200px;
                    }
                }
            }
        }

        .c-stepper__title {
            font-weight: bold;
            font-size: clamp(1rem, 4vw, 1.25rem);
            margin-bottom: clamp(0.85rem, 2vmax, 1rem);
        }
    }

    .amt-summary {
        padding-inline-start: 2.5rem;

        h4.title {
            font-size: 14px;
        }

        h6.title {
            font-size: 16px;

            b {
                font-weight: 700;
            }
        }
    }

    .c-stepper__item {
        position: relative;
        display: flex;
        gap: 1rem;
        padding-bottom: .875rem;
    }

    .c-stepper__desc {
        color: grey;
        font-size: clamp(0.85rem, 2vmax, 1rem);
    }


    .cart-deliver-summary {
        font-size: 16px;
        border-color: rgb(249, 249, 249);

        h4.title {
            color: var(--color-text-slight-dark);
            font-weight: 400;

            ${down("md")} {
                font-weight: 500
            }
        }
    }

    h5.subtitle {
        font-weight: 300;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 0;
        text-transform: capitalize;
    }

    p {
        color: #808080;
        font-weight: 400;
    }
}

${down("md")} {
    padding-bottom: 100px;

    > .container > .first_content.header {
        display: flex !important;

        .close-btn {
            display: block;
        }

        font-family: Archivo;
        font-weight: 700;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0px;
        text-transform: capitalize;
    }

    .mobile-sticky-checkout {
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        padding: 12px 16px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        border-top: 1px solid #e0e0e0;
    }

    .cart-icons-line.md-hidden {
        visibility: hidden;
    }

    .delivery-address img {
        width: 30px;
    }

    .cart-deliver-summary {
        font-size: 12px;
    }

    .c-stepper {
        > .c-stepper__item {
            position: relative;
            border-inline-start: 2px dashed #0B9C07;
            margin-inline-start: .75rem;
        }

        .c-stepper__dot {
            position: absolute;
            inset-inline-start: -1rem;

            > div {
                width: 30px;
                height: 30px;
            }
        }

        .c-stepper__content {
            flex: 1;
            padding-inline-start: 1.5rem;

            b {
                font-weight: 500;
            }
        }

        .c-stepper__dot {
            position: absolute;
            inset-inline-start: -.75rem;

            > div {
                width: 30px;
                height: 30px;

                &:before {

                }
            }
        }
    }

    .amt-summary {
        padding-inline-start: 2.5rem;

        h4.title, h6.title {
            font-size: 12px;
        }

        h5.subtitle {
            font-size: 12px;
            font-weight: 500;
        }
    }

    .cart-delivery-info-pad {
        padding: 12px;
        border-radius: 7.5px;
    }

`
export const GrayCardWrapper = styled.div`
    border: 1px solid #F2F2F7;
    background-color: #F9F9F9;
    padding: 18px 14px;
    border-radius: 7.5px;

    h5 {
        font-weight: 500;
        font-size: 14px;
        line-height: 100%;
        letter-spacing: .41px;
        text-transform: capitalize;
        color: #2B2B2B;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;

        span {
            font-weight: 400;
            font-size: inherit;
            letter-spacing: inherit;
            text-transform: inherit;
            color: inherit;
        }
    }

    > :not([hidden]) ~ :not([hidden]) {
        margin-top: .5rem;
        margin-bottom: .5rem;
    }

    ${down("sm")} {
        h5 {
            font-weight: 500;
            font-size: 10px;
            line-height: 100%;
            letter-spacing: 0.5px;
            text-transform: capitalize;

            span {
                font-weight: 400;
                font-size: 10px;
                line-height: 100%;
                letter-spacing: 0.5px;
                text-transform: capitalize;
            }
        }
    }
`